<template>
    <div>
        <van-popup v-model="show" position="bottom" round>
            <div class="index-prefer-detail">
                <div class="index-prefer-header">
                    <div class="index-prefer-title">优惠明细</div>
                    <div class="index-prefer-desc">实际优惠金额请以下单页为准</div>
                    <img class="close" @click="onPreferShow" src="../../assets/image/close@2x.png" />
                </div>
                <div class="index-prefer-content">
                    <div class="index-prefer-column">
                        <span class="index-prefer-label">商品总价</span>
                        <span class="index-prefer-value">￥{{preferDetail.totalGoodPrice||preferDetail.totalGoodsPrice}}</span>
                    </div>
                    <div class="index-prefer-column">
                        <span class="index-prefer-label">店铺优惠</span>
                        <span class="index-prefer-value color_1">-￥{{preferDetail.branchDiscount || 0}}</span>
                    </div>
                    <div class="index-prefer-column">
                        <span class="index-prefer-label">优惠券</span>
                        <span class="index-prefer-value color_1">-￥{{preferDetail.couponDiscount || preferDetail.couponDiscountPrice || 0}}</span>
                    </div>
                    <div class="index-prefer-column margin">
                        <span class="index-prefer-label">共优惠</span>
                        <span class="index-prefer-value color_1">-￥{{preferDetail.totalDiscount || 0}}</span>
                    </div>
                    <div class="index-prefer-column">
                        <span class="index-prefer-label">
                            合计<text class="label_1">（不含运费）</text>    
                        </span>
                        <span class="index-prefer-value">￥{{preferDetail.totalPrice}}</span>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
export default {
    props: {
        preferDetail: {
            type: Object,
            default: function() {
                return {}
            }
        }
    },
    data() {
        return {
            show: false
        }
    },
    methods: {
        onPreferShow() {
            this.show = !this.show
        }
    }
}
</script>

<style lang="less" scoped>
.index-prefer-detail {
    font-size: 24px;
    padding-bottom: 70px;
}
.index-prefer-header {
    height: 140px;
    position: relative;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
}
.index-prefer-header .close {
    width: 38px;
    height: 38px;
    position: absolute;
    right: 40px;
    top: 50%;
    transform: translateY(-50%);
}
.index-prefer-title {
    font-size: 32px;
    line-height: 45px;
    font-weight: 500;
    color: #000;
}
.index-prefer-desc {
    font-size: 20px;
    line-height: 28px;
    color: #999;
}
.index-prefer-column {
    height: 33px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    padding: 0 60px;
}
.index-prefer-column.margin {
    margin-top: 60px;
}
.index-prefer-label .label_1 {
    color: #999;
}
.index-prefer-value.color_1 {
    color: #ED3939;
}
</style>